<template>
  <div>
    <div
      class="vulTag"
      v-if="vulTagMap.length"
    >
      <el-tag
        class="vulTag-item"
        v-for="item in vulTagMap"
        :key="item.key"
        :type="item.tag"
        effect="dark"
        :color="item.color"
        size="mini"
        :style="clickable ? { cursor: 'pointer' } : {}"
        @click="handleClick(item)"
      >
        {{ item.value }}
      </el-tag>
    </div>
    <span v-else>--</span>
  </div>
</template>

<script>
const VulTagMap = [
  {
    key: 'criticalCount',
    severity: 'Critical',
    value: 0,
    tag: 'info',
    label: 'Critical',
    color: '#951d1d',
  },
  {
    key: 'highCount',
    severity: 'High',
    value: 0,
    tag: 'danger',
    label: 'High',
  },
  {
    key: 'mediumCount',
    severity: 'Medium',
    value: 0,
    tag: 'warning',
    label: 'Medium',
  },
  {
    key: 'lowCount',
    severity: 'Low',
    value: 0,
    tag: 'success',
    label: 'Low',
  },
];

export default {
  name: 'VulStat',
  props: {
    vulStat: {
      required: true,
    },
  },
  computed: {
    vulTagMap() {
      if (!this.vulStat) {
        return [];
      }

      return VulTagMap.map((item) => {
        const { key } = item;

        return {
          ...item,
          value: this.vulStat[key],
        };
      });
    },
    clickable() {
      return this.$listeners.click;
    },
  },
  methods: {
    handleClick(item) {
      this.$emit('click', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.vulTag {
  display: flex;

  &-item {
    min-width: 2em;
    margin: 0 2px;
    text-align: center;
    border: none;
  }
}
</style>